import createRecordNotification from 'components/Notification/createRecordNotification';
import './index.css';
import NOTIFICATION_STRINGS from './Constants/notificationString';

const CREATE_SUCCESS_KEY = 'work-order-create-success';
export const CREATE_CLASSNAME_PREFIX = 'work-order-creation';

const {
  notify: workOrderNotification,
  dismiss: dismissWorkOrderNotification
} = createRecordNotification<
  | 'CREATE_SUCCESS'
  | 'EDIT_SUCCESS'
  | 'CREATE_OR_EDIT_ERROR'
  | 'DELETE_SUCCESS'
  | 'DELETE_ERROR'
  | 'CONVERSION_DELETE_ERROR'
  | 'PDF_EXPORT_ERROR'
>({
  notificationKey: CREATE_SUCCESS_KEY,
  classNamePrefix: CREATE_CLASSNAME_PREFIX,
  strings: {
    SAVED: NOTIFICATION_STRINGS.WORK_ORDER_CREATED,
    UPDATED: NOTIFICATION_STRINGS.WORK_ORDER_UPDATED,
    DELETED: 'Work Order deleted.',
    DUPLICATE_BUTTON: NOTIFICATION_STRINGS.DUPLICATE_BUTTON,
    PRINT_PDF_BUTTON: NOTIFICATION_STRINGS.PRINT_PDF_BUTTON,
    ERROR_TITLE: NOTIFICATION_STRINGS.ERROR_TITLE,
    ERROR_MESSAGE: NOTIFICATION_STRINGS.ERROR_MESSAGE,
    DELETE_ERROR_TITLE: NOTIFICATION_STRINGS.DELETE_ERROR_TITLE,
    DELETE_ERROR_MESSAGE: NOTIFICATION_STRINGS.DELETE_ERROR_MESSAGE,
    CONTACT_BUTTON: NOTIFICATION_STRINGS.CONTACT_BUTTON,
    PDF_ERROR_TITLE: NOTIFICATION_STRINGS.PDF_ERROR_TITLE,
    PDF_ERROR_MESSAGE: NOTIFICATION_STRINGS.PDF_ERROR_MESSAGE,
    PDF_TRY_AGAIN_BUTTON: NOTIFICATION_STRINGS.PDF_TRY_AGAIN_BUTTON,
    VIEW_WORK_ORDER_BUTTON: NOTIFICATION_STRINGS.VIEW_WORK_ORDER_BUTTON
  }
});

export { dismissWorkOrderNotification };

export default workOrderNotification;
